import React from 'react'
import { Tooltip } from '@enamelai/design-system'
import { Icon as AiReceptionist } from '@enamelai/design-system/icons/ai_receptionist'
import './AiReceptionistIconStyle.css'

type AiReceptionistIconProps = {
  label: string
}

const AiReceptionistIcon = ({
  label,
}: AiReceptionistIconProps): React.ReactElement => (
  <Tooltip content={label} placement="top" portal>
    <span className="ai-receptionist-icon-wrap">
      <AiReceptionist className="ai-receptionist-icon" aria-label={label} />
    </span>
  </Tooltip>
)

export default AiReceptionistIcon
